<template>
  <div>
    <div class="card mt-4 mb-4">
      <div class="card-body">
        <div class="card-text text-center" v-html="config.listText">
          <!-- Hoi!<br>
          Leuk, je hebt de weg gevonden naar onze geboortewebsite!
          We willen je via deze weg een eerste blik geven op ons toffe zoontje.
          Daarnaast hebben we ook enkele van de spulletjes die we hebben gemaakt 
          en gekocht om onze Linus welkom te heten opgelijst, zodat je eraan kan bijdragen als je wil.  -->
        </div>
      </div>
    </div>
    <cards :elements="notFinished"></cards>
    <template v-if="!$_.isEmpty(finished)">
      <hr>
      <h1 class="display-5">Al gegeven</h1>
      <cards :elements="finished"></cards>
    </template>
    <template v-if="currentUser && currentUser.email">
      <hr>
      <h1 class="display-5">Nog verstopt</h1>
      <cards :elements="notToBeShown"></cards>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import cards from "./cards";
export default {
  components: { cards },
  computed: {
    ...mapState(["artikels", "currentUser", "config"]),
    toBeShown() {
      return this.$_.filter(this.artikels, x => x.show);
    },
    notToBeShown() {
      return this.$_.filter(this.artikels, x => !x.show);
    },
    notFinished() {
      return this.$_.filter(
        this.toBeShown,
        x => parseInt(x.prijs_donated) < parseInt(x.prijs)
      );
    },
    finished() {
      return this.$_.filter(
        this.toBeShown,
        x => parseInt(x.prijs_donated) >= parseInt(x.prijs)
      );
    }
  }
};
</script>

<style>
.artikel {
  cursor: pointer;
}
</style>
